import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card, cardClassName } from '@/components/ui/card';
import { IconTile } from '@/components/IconTile';
import { cn } from '@/lib/utils';

interface QuickLinkCardProps {
  to?: string;
  icon: React.ReactNode;
  title: string;
  description?: string;
  tags?: string[];
  className?: string;
}

export function QuickLinkCard({ to, icon, title, description, tags, className }: QuickLinkCardProps) {
  const body = (
    <>
      <IconTile icon={icon} size="md" />
      <div className="min-w-0 flex-1">
        <div className="font-medium text-ink-900 dark:text-foreground">{title}</div>
        {description && (
          <div className="mt-1 text-xs text-ink-500 dark:text-muted-foreground line-clamp-2">{description}</div>
        )}
        {tags && tags.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-1">
            {tags.map(tag => (
              <span
                key={tag}
                className="rounded-full bg-slate-100 px-2 py-0.5 text-[0.65rem] text-ink-500 dark:bg-ink-700 dark:text-ink-300"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
      {to && (
        <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-ink-400 transition group-hover:translate-x-0.5 group-hover:text-brand-500 dark:group-hover:text-primary" />
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cardClassName(cn('group flex items-start gap-4 transition hover:shadow-md', className))}>
        {body}
      </Link>
    );
  }

  return <Card className={cn('flex items-start gap-4', className)}>{body}</Card>;
}
